class UnauthorizedError extends Error {
    constructor(m?: string) {
        super(m);
    }
}

export default UnauthorizedError;
